"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Bool = ({
  schema,
  value,
  name,
  onChange
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    className: "custom-control-input",
    id: name,
    checked: value === true,
    onChange: event => onChange(event.target.checked)
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: 'custom-control-label text-muted text-uppercase'
  }, /*#__PURE__*/_react.default.createElement("small", null, schema.displayName)));
};
var _default = exports.default = Bool;
module.exports = exports.default;